import { render, staticRenderFns } from "./dataitem.vue?vue&type=template&id=066fd40e"
import script from "./dataitem.vue?vue&type=script&lang=js"
export * from "./dataitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports